import { Fab, FabOwnProps } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import { Dispatch, SetStateAction } from "react";

interface Props {
  color?: FabOwnProps["color"];
  size?: FabOwnProps["size"];
  iconSize?: string | number;
  setIsOpenMenu: Dispatch<SetStateAction<boolean>>;
}

const MiniCursoMenuFab = ({ color = 'error', size = 'medium', iconSize = 'x-large',  setIsOpenMenu } : Props) => {

  const Class = "bottom-[5.5rem] right-0 p-4 rounded-lg flex gap-2 fixed z-50 opacity-80";

  return (
    <div className={ Class }>
      <Fab 
        size={size}
        color={color}
        aria-label="go-down"
        style={{  boxShadow: "4px 4px 10px rgba(0,0,0,0.6)" }}
        onClick={() => setIsOpenMenu(true)}
      >
        <i className="text-black">
          <MenuIcon sx={{ fontSize: iconSize }}/>
        </i>
      </Fab>
    </div>
  )
}

export default MiniCursoMenuFab;